import EntityTypeEnum from 'common/enums/entityTypeEnum'
import WebinarSessionLinkInterface from 'common/types/entities/WebinarSessionLinkInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createWebinarSessionLink(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): WebinarSessionLinkInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarSessionLink,
      parentId,
      masterBlockId,
    ),
    color: 'rgba(0, 0, 238, 1)',
    fontSize: 30,
  }
}
